import React, { useState, useEffect } from 'react';

interface Props {
  id?: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  testId?: string;
}

export function SpinnerInput({ id, value, onChange, min = 0, max = 255, disabled, required, placeholder, style, testId }: Props) {
  const [text, setText] = useState(String(value));

  useEffect(() => { setText(String(value)); }, [value]);

  const commit = (v: number) => {
    const clamped = Math.min(max, Math.max(min, isNaN(v) ? min : v));
    setText(String(clamped));
    onChange(clamped);
  };

  const step = (delta: number) => commit((parseInt(text, 10) || 0) + delta);

  const btnBase: React.CSSProperties = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    width: 20,
    border: 'none',
    background: disabled ? '#eee' : '#f5f5f5',
    cursor: disabled ? 'default' : 'pointer',
    color: disabled ? '#aaa' : '#555',
    fontSize: 10,
  };

  return (
    <div style={{ display: 'flex', ...style }}>
      <input
        type="text"
        inputMode="numeric"
        id={id}
        data-testid={testId}
        className="form-control"
        style={{ flex: 1, minWidth: 0, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
        value={text}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        onChange={e => setText(e.target.value.replace(/\D/g, ''))}
        onBlur={() => commit(parseInt(text, 10) || 0)}
        onKeyDown={e => {
          if (e.key === 'ArrowUp') { e.preventDefault(); step(1); }
          if (e.key === 'ArrowDown') { e.preventDefault(); step(-1); }
        }}
      />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #ccc',
        borderLeft: 'none',
        borderRadius: '0 4px 4px 0',
        overflow: 'hidden',
        flexShrink: 0,
      }}>
        <button
          type="button"
          style={{ ...btnBase, borderBottom: '1px solid #ccc' }}
          data-testid="spinner-up-btn"
          disabled={disabled}
          tabIndex={-1}
          onMouseDown={e => e.preventDefault()}
          onClick={() => step(1)}
        >
          <i className="fas fa-caret-up" />
        </button>
        <button
          type="button"
          style={btnBase}
          data-testid="spinner-down-btn"
          disabled={disabled}
          tabIndex={-1}
          onMouseDown={e => e.preventDefault()}
          onClick={() => step(-1)}
        >
          <i className="fas fa-caret-down" />
        </button>
      </div>
    </div>
  );
}
